import { MemberModel } from '../models/data/member.model';
import { UserSessionService } from '../services/user-session.service';

export class MemberUtilities {

    // A member's display name ("First Last"), trimmed so a missing first or last name doesn't leave a
    // stray space. Names are optional here because a directory entry's are nullable in the API.
    public static fullName(member: { firstName?: string; lastName?: string }): string {
        return `${member.firstName ?? ''} ${member.lastName ?? ''}`.trim();
    }

    // Phone numbers are held as bare digits beneath the API boundary; the display pipes and the edit
    // form both add their own formatting, so punctuation left on a response gets formatted a second
    // time on top. Normalize every getMemberById response before it reaches a signal.
    public static withNormalizedPhone<T extends Pick<MemberModel, 'phoneNumber'>>(member: T): T {
        return { ...member, phoneNumber: member.phoneNumber?.replace(/\D/g, '') || '' };
    }

    // True when the member is linked to (and is) the logged-in user. A member without a linked user
    // can never be the current user, so the optional userId is null-checked first.
    public static belongsToCurrentUser(
        member: Pick<MemberModel, 'userId'>,
        userSessionService: UserSessionService
    ): boolean {
        return !!member.userId && userSessionService.isCurrentUser(member.userId);
    }
}
